// src/component/api/urls.ts
export const BASE_URL = "https://api.feebdack.in";

export const API_URLS = {
  // Authentication endpoints
  ADMIN_LOGING: `${BASE_URL}/admin/login`,
  VERIFY_CAPACHA: `${BASE_URL}/admin/verify_captcha`,
  VERIFY_OTP: `${BASE_URL}/admin/verify_otp`,

  GET_ADMIN_DETAILS:(admin_id: number) => `${BASE_URL}/admin/get_admin_details/${admin_id}`,

  GET_DASHBOARD_DETAILS:(admin_id: number) => `${BASE_URL}/admin/get_dashboard_details?admin_id=${admin_id}`,
  GET_ALL_USER_LIST:(admin_id: number, page:number , page_limit:number ) => `${BASE_URL}/admin/get_all_users_list?admin_id=${admin_id}&page=${page}&page_limit=${page_limit}`,
  GET_USER_DETAILS:(user_id: number) => `${BASE_URL}/admin/get_user_details/${user_id}`,

  GET_OTP_TO_CHANGE_PASSWORD: `${BASE_URL}/admin/password/send_otp`,
  VERIFY_OTP_TO_CHANGE_PASSWORD: `${BASE_URL}/admin/password/verify_otp`,
  CHANGE_PASSWORD: `${BASE_URL}/admin/password/update`,
}